import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment, api } from '../../../environments/environment';

import { AuthenticationService } from '../services/auth.service';
import {JwtAuthService} from "../services/jwt-auth.service";
import { SpringAuthService } from '../services/spring-auth.service';
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(
      private authenticationService: AuthenticationService,
      private springAuth: SpringAuthService
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if (err.status === 401) {
                // auto logout if 401 response returned from api
              if (environment.defaultauth === 'springSecurity') {
                this.springAuth.signout();
              }else{
                this.authenticationService.logout();
              }

                // location.reload();
            }

            const error = err.error.message || err.statusText;
            return throwError(error);
        }));
    }
}
